(function() {
  'use strict';

  angular
    .module('client', ['ui.router', 'toastr']);

})();

(function() {
  'use strict';

  angular
      .module('client')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('client')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('client')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('client')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('client')
        .controller('MainController', MainController);

    MainController.$inject = ['$state', '$scope', '$location', '$http', '$q', '$log'];
    /** @ngInject */
    function MainController($state, $scope, $location, $http, $q, $log) {
        $scope.windowLocation = window.location;
        var randomString = function(length) {
            var chars = '0123456789';
            var result = '';
            for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
            return result;
        }
        var dt = new Date();
        $scope.user = {
            "uid": '',
            "initHash": '',
            "purpose": 'Aadhaar Auth transaction for ',
            "timestamp": dt.getTime().toString(),
            "requestId": randomString(15) + dt.getSeconds()
        };
        $scope.customer = {
            "logoUrl": "",
            "name": ""
        };
        // console.log("MainController", window.location);
        var hide_show = function(selector, prop) {
            var ele = document.getElementById(selector);
            if (prop == 'show')
                ele.style.display = "block";
            else
                ele.style.display = "none";
        }



        $scope.getFormParams = function() {
            // hide_show('invalidUid', 'hide');
            // console.log($scope.user);
            var requestObj = {
                "task": "init",
                "params": $scope.user
            };

            $http.post('/api/v2/authhandlers', requestObj).then(function(response) {
                $scope.user.initHash = response.data.result;
                // console.log("user obj ", $scope.user);
                $scope.createOtpForm();
            }, function(err) {
                // console.log("err", err);
                $state.go('error');
            });

        }

        $scope.createOtpForm = function() {
            // hide_show('uid-form', 'hide');
            hide_show('redirectForm', 'show');
            // document.getElementById('uid').value = $scope.user.uid;
            // console.log("$scope.user", $scope.user.timestamp);
            document.getElementById('requestId').value = $scope.user.requestId;
            document.getElementById('ts').value = $scope.user.timestamp;
            document.getElementById('purpose').value = $scope.user.purpose + $scope.customer.name;
            document.getElementById('hash').value = $scope.user.initHash;
            setTimeout(function() {
                document.getElementById('redirectForm').submit();
            }, 300);
        }
        var getQueryParam = function(name) {
            var url = window.location.href;
            // var url = 'https://signzy.tech/?hash=ff46c4397d1c43862452982addf7016d2124284267677fe17e5f05c4aa1bb90b&uuid=86f94dd5-f167-4fea-8e78-2c38f3ad02b9&requestId=41116704073170435&status=success';
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        var parseData = function(input) {
            $scope.user.uid = input.authResponse.uid;
            localStorage.setItem("uid", input.authResponse.uid);
            localStorage.setItem("callbackUrl", input.authResponse.callbackUrl);
            $scope.customer.redirectUrl = input.authResponse.redirectUrl;
            localStorage.setItem("redirectUrl", input.authResponse.redirectUrl);
            $scope.customer.patronId = input.patronId;
            localStorage.setItem("patronId", input.patronId);
            $scope.customer.token = input.token;
            localStorage.setItem("token", input.token);
            $scope.customer.logoUrl = input.authResponse.logoUrl;
            localStorage.setItem("logoUrl", input.authResponse.logoUrl);
            $scope.customer.name = input.authResponse.name;
            localStorage.setItem("name", input.authResponse.name);


        }



        $scope.checkCustomer = function() {
            $scope.token = getQueryParam('token');
            localStorage.clear();
            var url = "/api/v2/authhandlers";
            var data = {
                "task": "start",
                "token": getQueryParam('token'),
                "patronId": window.location.pathname.slice(1).replace(/customer--/ig, '')
            };
            $http.post(url, data).then(function(response) {
                    // console.log("response", response.data);
                    parseData(response.data);
                    $scope.getFormParams();
                },
                function(err) {
                    $state.go('expired');
                });
        }
        $scope.checkCustomer();
    }
})();

(function() {
    'use strict';

    angular
        .module('client')
        .controller('AadhaarAuthController', AadhaarAuthController);

    AadhaarAuthController.$inject = ['$state', '$scope', '$location', '$http', '$q', '$log'];
    /** @ngInject */
    function AadhaarAuthController($state, $scope, $location, $http, $q, $log) {
        // console.log("AadhaarAuth controller", window.location);
        $scope.user = {
            "ekyc": {},
            "error": {}
        };
        $scope.customer = {};
        $scope.authResponse = false;
        $scope.authError = false;
        $scope.notLinked = false;
        var hide_show = function(selector, prop) {
            var ele = document.getElementById(selector);
            if (prop == 'show')
                ele.style.display = "block";
            else
                ele.style.display = "none";
        }
        var getQueryParam = function(name) {
            var url = window.location.href;
            // var url = 'https://signzy.tech/?hash=ff46c4397d1c43862452982addf7016d2124284267677fe17e5f05c4aa1bb90b&uuid=86f94dd5-f167-4fea-8e78-2c38f3ad02b9&requestId=41116704073170435&status=success';
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        $scope.postData = function(callbackUrl) {
            $http.post(callbackUrl, $scope.user.ekyc).then(function(response) {
                // console.log("Data posted Successfully");
            }, function(err) {
                // console.log("Error in posting");
            });
        }
        $scope.getCustomers = function() {
            $scope.customer.callbackUrl = localStorage.getItem('callbackUrl');
            $scope.customer.name = localStorage.getItem('customerName');
            $scope.customer.logoUrl = localStorage.getItem('logoUrl');
            $scope.customer.redirectUrl = localStorage.getItem('redirectUrl');
        }
        $scope.getCustomers();

        $scope.redirect = function() {
            // console.log("redirect function called");
            if (angular.isDefined($scope.customer.redirectUrl) && $scope.customer.redirectUrl != null && $scope.customer.redirectUrl != '' && $scope.customer.redirectUrl.toLowerCase().indexOf('http') > -1) {
                window.setTimeout(function() {
                    window.location.href = $scope.customer.redirectUrl;
                }, 5000);
            }
        }



        $scope.saveData = function(finalObj) {
            // hide_show('invalidUid', 'hide');
            // console.log(finalObj);
            var requestObj = {
                "task": "end",
                "params": finalObj
            };

            $http.post('/api/v2/authhandlers', requestObj).then(function(response) {
                // console.log("response ", response);
                $scope.redirect();
            }, function(err) {
                // console.log("err ", err);
                $scope.redirect();
            });

        }

        $scope.authRequest = function() {
            var finalObj = {
                verified: '',
                message: '',
                success: '',
                errorCode: '',
                uuid: '',
                token: localStorage.getItem('token'),
                patronId: localStorage.getItem('patronId')
            };
            finalObj.success = getQueryParam('success')
            finalObj.uid = getQueryParam('aadhaarId')
            finalObj.errorCode = typeof getQueryParam('errorCode') != 'undefined' && getQueryParam('errorCode') != null ? getQueryParam('errorCode') : '';
            finalObj.errorCode = finalObj.errorCode.toString();
            finalObj.uuid = getQueryParam('uuid')
                // console.log("finalObj", finalObj);
            if (typeof $scope.customer.callbackUrl == 'undefined' || $scope.customer.callbackUrl == null || $scope.customer.callbackUrl.length == 0)
                $scope.customer.callbackUrl = "https://www.signzy.com";
            if (finalObj.success == 'true') {
                $scope.authResponse = true;
                finalObj.verified = "true";
                finalObj.message = 'Verification complete with positive results';

            } else {
                if (finalObj.success == 'false' && finalObj.errorCode.toUpperCase().indexOf('AB') > -1) {
                    $scope.authResponse = false;
                    $scope.authError = true;
                    $scope.notLinked = false;
                    finalObj.verified = "notVerified";
                    finalObj.message = 'Verification couldnot be completed';
                } else if (finalObj.success == 'false' && finalObj.errorCode == 112) {
                    $scope.authResponse = false;
                    $scope.authError = false;
                    $scope.notLinked = true;
                    finalObj.verified = "notVerified";
                    finalObj.message = 'Verification couldnot be completed';
                } else {
                    $scope.authResponse = true;
                    $scope.authError = false;
                    $scope.notLinked = false;
                    finalObj.verified = "false";
                    finalObj.message = 'Verification complete with negative results';
                }
                // $scope.authResponse = false;
                // // console.log("success", success);
                // $scope.redirect();
            }
            // console.log("finalObj", finalObj);
            // console.log("ASasas", $scope.authResponse);
            // console.log("ASasas", $scope.authError);
            $scope.saveData(finalObj)

        }
        $scope.authRequest();
    }
})();

(function() {
  'use strict';

  angular
    .module('client')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    // console.log('runBlock end');
  }

})();

(function() {
    'use strict';

    angular
        .module('client')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('home', {
                url: '/',
                templateUrl: 'app/error/error.html'
            })
            .state('customer', {
                url: '/customer--:customerId',
                templateUrl: 'app/main/main.html',
                controller: 'MainController'
            })
            .state('aadhaarauth', {
                url: '/aadhaarauth--:token',
                templateUrl: 'app/aadhaarauth/aadhaarauth.html',
                controller: 'AadhaarAuthController'
            })
            .state('error', {
                url: '/error',
                templateUrl: 'app/error/error.html'
            })
            .state('expired', {
                url: '/expired',
                templateUrl: 'app/expired/expired.html'
            });


        $urlRouterProvider.otherwise('/error');
        // console.log('allah')
    }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('client')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function () {
    'use strict';

    angular
        .module('client')
        .config(config);

    /** @ngInject */
    function config($logProvider, toastrConfig, $locationProvider) {
        // Enable log
        $logProvider.debugEnabled(true);

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        }).hashPrefix('!');

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = true;
        toastrConfig.progressBar = true;
    }

})();

angular.module("client").run(["$templateCache", function($templateCache) {$templateCache.put("app/aadhaarauth/aadhaarauth.html","<div class=\"w3-container w3-black\"><img class=logo-img ng-src={{customer.logoUrl}}></div><div class=\"w3-row w3-margin-top\"><div class=\"w3-col l2 m1 w3-hide-small\">&nbsp;</div><div class=\"w3-col l8 m10 s12\"><div class=\"w3-card-4 mar50 bg-white\"><div class=\"w3-container w3-blue w3-center\"><h2>Aadhaar EKYC</h2></div><div class=w3-row><div class=\"w3-col l12 w3-center w3-padding-16\" ng-hide=\"authResponse || authError || notLinked\"><div class=spinner></div></div><div class=pad-bot ng-show=authResponse><div class=w3-row><div class=\"w3-col l12 w3-center hdr w3-text-green w3-xlarge\">Your Aadhaar Auth Transaction is Completed</div><div class=\"w3-col l12 w3-center\"><div ng-if=\"customer.redirectUrl.length > 0\" class=pad20>You will be redirected to <span ng-bind=customer.redirectUrl></span> ...</div></div></div></div><div ng-show=authError class=pad-bot><div class=w3-row><div class=\"w3-col l12 w3-center hdr w3-text-red w3-xlarge\">You have declined your Aaadhaar Auth Transaction</div><div class=\"w3-col l12 w3-center\"><div ng-if=\"customer.redirectUrl.length > 0\" class=pad20>You will be redirected to <span ng-bind=customer.redirectUrl></span> ...</div></div></div></div><div ng-show=notLinked class=pad-bot><div class=w3-row><div class=\"w3-col l12 w3-center hdr w3-text-red w3-xlarge\">Your Mobile Number is not linked to Aadhaar</div><div class=\"w3-col l12 w3-center\"><div ng-if=\"customer.redirectUrl.length > 0\" class=pad20>You will be redirected to <span ng-bind=customer.redirectUrl></span> ...</div></div></div></div></div></div></div><div class=\"w3-col l2 m1 w3-hide-small\">&nbsp;</div></div>");
$templateCache.put("app/error/error.html","<style media=screen>html, body{\n    background: #C0392B;\n    height: 100%;\n    margin:0;\n    padding:0;\n    overflow: hidden;\n}\n\ndiv {\n    background: #C0392B;\n    position:relative;\n    height: 100%;\n    width:100%;\n}\n\ndiv img {\n    position:absolute;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    margin:auto;\n}</style><div><img src=https://statics.signzy.tech/api-docs/lib/images/logo_header.png></div><script type=text/javascript>var removeFooter = function(){\n    document.getElementById(\'footer-block\').style.display=\"none\";\n}\nremoveFooter();</script>");
$templateCache.put("app/expired/expired.html","<style media=screen>html, body{\n    background: #C0392B;\n    height: 100%;\n    margin:0;\n    padding:0;\n    overflow: hidden;\n}\n\ndiv {\n    background: #C0392B;\n    position:relative;\n    height: 100%;\n    width:100%;\n}\n\ndiv img {\n    position:absolute;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n    margin:auto;\n}\n.error-msg{\n    text-align: center;\n    padding: 66px;\n    color: #1c1f1d;\n}</style><div><div><h1 class=error-msg>URL has expired</h1></div><img src=https://statics.signzy.tech/api-docs/lib/images/logo_header.png></div><script type=text/javascript>var removeFooter = function(){\n    document.getElementById(\'footer-block\').style.display=\"none\";\n}\nremoveFooter();</script>");
$templateCache.put("app/main/main.html","<div class=\"w3-container w3-black\"><img class=logo-img ng-src={{customer.logoUrl}}></div><div class=\"w3-row w3-margin-top\"><div class=\"w3-col l2 m1 w3-hide-small\">&nbsp;</div><div class=\"w3-col l8 m10 s12\"><div class=\"w3-card-4 mar50 bg-white\"><div class=\"w3-container w3-blue w3-center\"><h2>Aadhaar Auth</h2></div><div class=w3-row><!-- <form class=\"w3-container w3-section\" ng-submit=\"getFormParams();\" name=\"uidform\" id=\"uid-form\" novalidate method=\"post\">\n                    <div class=\"w3-col l4 m4 s2\">&nbsp;</div>\n                    <div class=\"w3-col l4 m4 s8 w3-center\">\n                        <input class=\"w3-input w3-border\" type=\"text\" placeholder=\"ENTER UID\" name=\"Uid\" ng-readonly=\"user.uid.length == 12\" ng-model=\"user.uid\" maxlength=\"12\" ng-minlength=\"12\" ng-pattern=\"/^\\d+$/\" required>\n                        <div ng-show=\"uidform.$submitted || uidform.Uid.$touched\" class=\"\">\n                            <div ng-show=\"uidform.Uid.$error.required\" class=\"w3-text-red\">Aadhaar is required.</div>\n                            <div ng-show=\"uidform.Uid.$error.minlength && !uidform.Uid.$error.pattern \" class=\"w3-text-red\">Aadhaar should be of 12 characters.</div>\n                            <div ng-show=\"uidform.Uid.$error.pattern\" class=\"w3-text-red\">This is not a valid Aadhaar Number.</div>\n                        </div>\n                        <div class=\"w3-text-red disp-none\" id=\"invalidUid\">This is not a valid Aadhaar Number.</div>\n                        <div class=\"pad20\">\n                            <input class=\"w3-check\" type=\"checkbox\" ng-model=\"tnc\" style=\"width:20px;height:22px\" checked=\"checked\">\n                            <label style=\"padding-left: 10px;\"> I agree to terms below</label>\n                        </div>\n                        <button type=\"submit\" value=\"submit\" class=\"w3-btn btn-mar w3-blue\" ng-disabled=\"uidform.$invalid || !tnc\" ng-hide=\"hideOtpBtn\">CONFIRM</button>\n                        <div class=\"spinner\" ng-show=\"loading.otp\"></div>\n                    </div>\n                    <div class=\"w3-col l4  m4 s2\">&nbsp;</div>\n                    <div class=\"w3-col l12  m12 s12  w3-center\">\n                        <h6 class=\"text-bold\">Terms and Conditions</h6>\n                    </div>\n                    <div class=\"w3-col l12  m12 s12 w3-small\">\n                        <ul>\n                            <li>I, the Holder of Aadhaar number given above, hereby give my consent to Signzy Technologies Private Limited to use my Aadhaar number and demographic details to authenticate whether they are true or not by using the AUA services of Khosla for purpose of establishing identity with UIDAI. I consent that such data post confirmation will be transferred to Client for further processing my onboarding application for their product and will not be stored or shared in any other manner by Signzy Technologies Private Limited.</li>\n                            <li>The user gives his consent to Signzy to share this information with <span class=\"clientname\" ng-bind=\"customer.name\"></span> for the purposes of verification of identity and demographics by the <span class=\"clientname\" ng-bind=\"customer.name\"></span>. The information of the Aadhar holder will not be used in any other manner and will not be stored other than as required under the Aadhar Act, 2016 and Regulations.</li>\n                        </ul>\n                    </div>\n                </form> --><form class=\"w3-container w3-section disp-none\" method=post id=redirectForm action=https://prod.aadhaarbridge.com/api/_init><div class=\"w3-col l4 m4 s2\">&nbsp;</div><div class=\"w3-col l4 m4 s8 w3-center\"><input type=hidden name=saCode value=011303> <input type=hidden name=api value=AUTH> <input type=hidden id=requestId name=requestId> <input type=hidden id=ts name=timeStamp> <input type=hidden id=purpose name=purpose> <input type=hidden id=otp name=otp value=Y> <input type=hidden id=fingerPrint name=fingerPrint value=N> <input type=hidden id=iris name=iris value=N> <input type=hidden id=face name=face value=N> <input type=hidden id=channel name=channel value=BOTH> <input type=hidden name=successUrl value={{windowLocation.origin}}/aadhaarauth--{{token}}> <input type=hidden name=failureUrl value={{windowLocation.origin}}/aadhaarauth--{{token}}> <input type=hidden id=hash name=hash> <button type=submit value=submit class=\"w3-btn btn-mar\" type=submit>Proceeding to Aadhaar Auth, please wait...</button></div><div class=\"w3-col l4 m4 s2\">&nbsp;</div></form></div></div></div><div class=\"w3-col l2 m1 w3-hide-small\">&nbsp;</div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=navbar><a href=https://github.com/Swiip/generator-gulp-angular>Gulp Angular</a><ul><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=acme-navbar-text><li>Application was created {{ vm.relativeDate }}.</li></ul></nav>");}]);